module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Tweekit","short_name":"Tweekit","start_url":"/","background_color":"#ffffff","theme_color":"#FF6F28","display":"standalone","icon":"src/images/favicon/light_mode.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c23b8fe7da8d43ee29f2fc78b73ce69d"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
